module.exports = __webpack_public_path__ + "img/icon-arrow.be7edbdd.svg";